import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ActionMenuItem } from '@/types/menu';
import { cn } from '@/lib/utils';

interface ActionButtonsProps {
  items: ActionMenuItem[];
  className?: string;
  onClick?: () => void;
}

export function ActionButtons({
  items,
  className,
  onClick,
}: ActionButtonsProps) {
  return (
    <div className={cn('flex items-center gap-4', className)}>
      {items.map((item) => {
        if (item.href)
          return (
            <Button
              key={item.href}
              variant={item.variant}
              asChild
              onClick={onClick}
              className={cn('w-full btn posicao', item.className)}
            >
              <Link href={item.href}>{item.label}</Link>
            </Button>
          );
      })}
    </div>
  );
}
